(function () {
  function initSizeGuide() {
    const drawer = document.querySelector('.size-guide-drawer');
    if (!drawer) return;

    document.addEventListener('click', function (e) {
      const openBtn = e.target.closest('.size-guide-trigger');
      const closeBtn = e.target.closest('.size-guide-close');
      const overlay = e.target.closest('.size-guide-overlay');

      if (openBtn) {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('size-guide-open');
      }

      if (closeBtn || overlay) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('size-guide-open');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initSizeGuide);
})();
